module.exports = __webpack_public_path__ + "static/sift-completed-c04bfe1efa4ad95118f825256d986744.png";